export function dateLabel(row) {
  if (!row.known_date || row.date_precision === 'unknown') return 'Date inconnue'
  return row.known_date.split('-').reverse().join('/')
}
export function newVaccinationKey() {
  const bytes=new Uint8Array(16);window.crypto.getRandomValues(bytes);bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128
  const hex=Array.from(bytes,b=>b.toString(16).padStart(2,'0')).join('')
  return [hex.slice(0,8),hex.slice(8,12),hex.slice(12,16),hex.slice(16,20),hex.slice(20)].join('-')
}
export function escapeHtml(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))
}
export function recordPayload(form, key) {
  const result = { request_key: key }
  for (const field of ['vaccine_name','dose_label','date_precision','known_date','origin','facility','practitioner','batch_number','route','site','notes']) {
    result[field] = String(form[field] || '').trim() || null
  }
  if (result.date_precision === 'unknown') result.known_date = null
  if (result.route === 'ORAL') result.site = null
  return result
}
